module.exports = __webpack_public_path__ + "images/peugeot_small4b0c10e98fd72afd519554a307384eb9.png";